import React, { useEffect, useState } from 'react'
import { Circle, Group, Line } from 'react-konva'

const ViewLayerPolygon: React.FC<{
    imageSize: any
    polygon: any
}> = (props) => {
    const [viewConfigPolygon, setViewConfigPolygon] = useState<any>([])
    useEffect(() => {
        setViewConfigPolygon(props.polygon)
    }, [props.polygon, props.imageSize.width, props.imageSize.height])

    if (!viewConfigPolygon || !viewConfigPolygon.points || viewConfigPolygon.points.length === 0) {
        return null
    }
    return (
        <Group name="polygon" preventDefault={false}>
            <Line points={viewConfigPolygon.flattenedPoints} stroke="#00F1FF" strokeWidth={8} />
            {viewConfigPolygon.lines.map((line: any) => {
                const line_style =
                    line.ref === true
                        ? {
                              stroke: '#ffdb28'
                          }
                        : {
                              stroke: '#00F1FF'
                          }
                return (
                    <Line
                        key={line.name}
                        name={line.name}
                        points={line.points.flat()}
                        strokeWidth={8}
                        fill="rgb(140,30,255,0.5)"
                        {...line_style}
                    />
                )
            })}
            {viewConfigPolygon.points.map((point: any, index: number) => {
                return (
                    <Circle
                        key={index}
                        x={point[0]}
                        y={point[1]}
                        radius={8}
                        fill="#e95d95"
                        stroke="#515151"
                        strokeWidth={2}
                    />
                )
            })}
        </Group>
    )
}

export default ViewLayerPolygon
